import { Box, Grid, styled } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";

import { Context } from "../../../context/context";
import { createCookieInHour } from "../../../utils/cookie";
import { MemoizedImageSlider } from "./imagegallery";
import { MemoizedVehicleDetailsData } from "./vehicleDetails";

const CustomVehicleData = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    position: "relative",
    top: "-36px",
  },
}));
const LeadCaptureMain = ({
  vehicleData,
  vehicleDataImageSlider,
  type,
  experiment,
}) => {
  const state = useContext(Context);
  const { updateEmiPriceValue } = useContext(Context);
  let curr_state = state.selectedState;
  const stateArray = ["Karnataka", "Maharashtra", "Tamil Nadu", "Telangana"];
  const index = stateArray.indexOf(curr_state);

  if (index === -1) curr_state = "Others";

  const [price, setPrice] = useState(
    vehicleData?.prices[state?.selectedState ?? "Others"]?.pickup?.price ??
      vehicleData?.prices[state?.selectedState ?? "Others"]?.full_body?.price ??
      vehicleData?.prices[state?.selectedState ?? "Others"]?.flat_bed?.price
  );
  const [emiPrice, setEMIPrice] = useState(
    vehicleData?.prices[state?.selectedState ?? "Others"]?.pickup?.emiPrice ??
      vehicleData?.prices[state?.selectedState ?? "Others"]?.full_body
        ?.emiPrice ??
      vehicleData?.prices[state?.selectedState ?? "Others"]?.flat_bed?.emiPrice
  );

  const handleThumbnailClick = (obj) => {
    let cookie_payload = {
      slided: true,
    };
    createCookieInHour("user_slided", cookie_payload, 10);
    setPrice(vehicleData?.prices[curr_state][obj?.type]?.price);
    updateEmiPriceValue(vehicleData?.prices[curr_state][obj?.type]?.emiPrice);
    setEMIPrice(vehicleData?.prices[curr_state][obj?.type]?.emiPrice);
  };

  const [images, setImages] = useState(null);

  useEffect(() => {
    setImages(
      vehicleDataImageSlider?.map((image, index) => {
        const obj = {
          original: "",
          originalAlt: vehicleData?.brand,
          thumbnailAlt: vehicleData?.brand,
          thumbnail: "",
          thumbnailLabel: "",
          originalHeight: "100px",
          originalWidth: "100px",
          type: "",
        };
        setPrice(
          vehicleData?.prices[curr_state]["pickup"]?.price ??
            vehicleData?.prices[curr_state]["full_body"]?.price ??
            vehicleData?.prices[curr_state]["flat_bed"]?.price
        );
        setEMIPrice(
          vehicleData?.prices[curr_state]["pickup"]?.emiPrice ??
            vehicleData?.prices[curr_state]["full_body"]?.emiPrice ??
            vehicleData?.prices[curr_state]["flat_bed"]?.emiPrice
        );
        updateEmiPriceValue(
          vehicleData?.prices[curr_state]["pickup"]?.emiPrice ??
            vehicleData?.prices[curr_state]["full_body"]?.emiPrice ??
            vehicleData?.prices[curr_state]["flat_bed"]?.emiPrice
        );

        if (
          state?.emiPriceValue === undefined ||
          state?.emiPriceValue?.length === 0
        ) {
          updateEmiPriceValue(
            vehicleData?.prices[curr_state]["pickup"]?.emiPrice ??
              vehicleData?.prices[curr_state]["full_body"]?.emiPrice ??
              vehicleData?.prices[curr_state]["flat_bed"]?.emiPrice
          );
          setEMIPrice(
            vehicleData?.prices[curr_state]["pickup"]?.emiPrice ??
              vehicleData?.prices[curr_state]["full_body"]?.emiPrice ??
              vehicleData?.prices[curr_state]["flat_bed"]?.emiPrice
          );

          // updateEmiPriceValue(
          //   vehicleData?.prices[curr_state]["pickup"]?.emiPrice
          // );
          // setEMIPrice(vehicleData?.prices[curr_state]["pickup"]?.emiPrice);
        }

        obj.original = image?.src;
        if (vehicleData.id === 3) {
          if (image.id === 7) {
            obj.thumbnail = image?.src;
            obj.thumbnailLabel = "Flat Bed";
            obj.thumbnailAlt = "Mahindra Flat Bed";
            obj.type = "flat_bed";
          } else if (image.id === 9) {
            obj.thumbnail = image?.src;
            obj.thumbnailLabel = "Pickup";
            obj.thumbnailAlt = "Mahindra Pickup";
            obj.type = "pickup";
          }
        }
        if (vehicleData.id === 2) {
          if (image.id === 6) {
            obj.thumbnail = image?.src;
            obj.thumbnailLabel = "Flat Bed";
            obj.type = "flat_bed";
            obj.thumbnailAlt = "Piaggio Flat Bed";
          } else if (image.id === 8) {
            obj.thumbnail = image?.src;
            obj.thumbnailLabel = "Pickup";
            obj.type = "pickup";
            obj.thumbnailAlt = "Piaggio Pickup";
          }
        }
        if (
          (vehicleData?.id === 3 && image?.id === 8) ||
          (vehicleData?.id === 2 && image?.id === 7)
        ) {
          obj.thumbnail = image?.src;
          obj.thumbnailLabel = "Full Body";
          obj.type = "full_body";
          obj.thumbnailAlt =
            vehicleData?.id === 3 ? "Mahindra Full Body" : "Piaggio Full Body";
        }
        if (vehicleData?.id === 4 && image?.id === 2) {
          obj.thumbnail = image?.src;
          obj.thumbnailLabel = "Pickup";
          obj.type = "pickup";
          obj.thumbnailAlt = "Etrio Pickup";
        }
        if (
          (vehicleData?.id === 4 && image?.id === 3) ||
          (vehicleData?.id === 6 && image?.id === 8)
        ) {
          obj.thumbnail = image?.src;
          obj.thumbnailLabel = "Full Body";
          obj.type = "full_body";
          obj.thumbnailAlt =
            vehicleData?.id === 4 ? "Etrio Full Body" : "OSM Full Body";
        }
        if (vehicleData?.id === 6) {
          if (image.id === 7) {
            obj.thumbnail = image?.src;
            obj.thumbnailLabel = "Flat Bed";
            obj.type = "flat_bed";
            obj.thumbnailAlt = "OSM Flat Bed";
          } else if (image.id === 1) {
            obj.thumbnail = image?.src;
            obj.thumbnailLabel = "Pickup";
            obj.type = "pickup";
            obj.thumbnailAlt = "Osm Pickup";
          }
        }
        return obj;
      })
    );
    // eslint-disable-next-line
  }, [vehicleDataImageSlider, state?.showStatePopupValue]);

  return (
    <CustomVehicleData>
      <Box>
        <Grid container spacing={2}>
          <Grid
            sx={{
              display: "block",
              position: "relative",
              pt: { xs: "0 !important" },
              minHeight: "400px",
            }}
            item
            xs={12}
            md={6}
          >
            <MemoizedImageSlider
              vehicleData={vehicleData}
              images={images}
              handleThumbnailClick={handleThumbnailClick}
            />
          </Grid>
          <Grid sx={{ display: "block" }} item xs={12} md={6}>
            <MemoizedVehicleDetailsData
              experiment={experiment}
              vehicleData={vehicleData}
              price={price}
              emiPrice={emiPrice}
              type={type}
            />
          </Grid>
        </Grid>
      </Box>
    </CustomVehicleData>
  );
};
export const MemoizedLeadCaptureMain = React.memo(LeadCaptureMain);
